export const splashScreenTypes = {
  pictureInPicture: 'pictureInPicture',
  maxParticipants: 'maxParticipants',
};
